import { useAuth0 } from 'contexts';
import { PermissionEnum } from 'enums';
import jwtDecode from 'jwt-decode';

interface MerchantApplicationFunctions {
  checkTokenPermission: (permission: PermissionEnum) => boolean;
}

export const useMerchantApplication = (): MerchantApplicationFunctions => {
  const { accessToken } = useAuth0();

  function checkTokenPermission(permission: PermissionEnum): boolean {
    const permissions = getTokenPermissions();

    return permissions.indexOf(permission.toString()) >= 0;
  }

  function getTokenPermissions(): string[] {
    const claims = jwtDecode(accessToken);
    if (!claims) {
      return null;
    }

    return claims['permissions'];
  }

  return {
    checkTokenPermission,
  };
};

export default useMerchantApplication;
